import "@/router/class-component-hooks";
// import { Component } from "vue-property-decorator";
import Vue from "vue";
import App from "@/views/App/App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import GlobalMixin from "./mixins/GlobalMixin";
import { LocaleService } from "./services/locale.service";
import moment from "moment";
import { actStatusFilter, formatDecimal2 } from "@/utils";

Vue.mixin(GlobalMixin);

import "@/assets/css/roboto.scss";
import "@/assets/css/index.scss";

LocaleService.init();

Vue.config.productionTip = false;

Vue.filter("formatDate", function(value: Date) {
  if (value) {
    return moment(String(value)).format("DD.MM.YYYY");
  }
});

Vue.filter("formatPhone", function(value: string) {
  if (value) {
    const match = value.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/);
    if (match) {
      return (
        "+" +
        match[1] +
        "(" +
        match[2] +
        ")" +
        match[3] +
        "-" +
        match[4] +
        "-" +
        match[5]
      );
    }
    return null;
  }
});

Vue.filter("formatDateMMYYYY", function(value: Date) {
  if (value) {
    return moment(String(value)).format("MM.YYYY");
  }
});

Vue.filter("formatDecimal3", function(value: number) {
  if (value || value === 0) {
    const fixedValue = Number(value).toFixed(3);
    const dotIndex = fixedValue.indexOf(".");

    const float = fixedValue.substr(dotIndex + 1);
    const real = fixedValue.substring(0, dotIndex);
    const parsedReal = new Intl.NumberFormat().format(parseInt(real));

    return `${parsedReal}.${float}`;
  }
});

Vue.filter("formatNumThousandsDelimiter", function(
  value: number,
  delimiter: string = " ",
) {
  return !value
    ? value
    : value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${delimiter}`);
});

Vue.filter("formatDecimal2", formatDecimal2);

Vue.filter("actStatusFilter", actStatusFilter);

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app");
